import React, { useState } from "react";
import { convertStringToArray } from "../../../Utils/utils";
import LightBox from "../../../components/LightBox/LightBox";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import PhotoCard from "../../../components/PhotoCard";
import { imageUrl } from "../../../constants/constants";

const PhotoGalleryEnv = ({ data }) => {
  const photoArray = convertStringToArray(data?.field_environment_photos);

  const { getText } = useLanguageTranslation();
  const [visible, setVisible] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const photoGallery = photoArray?.map((url) => {
    return {
      title: url.title,
      src: imageUrl + url.file_path,
    };
  });
  return (
    <>
      <div className="container">
        <div className="title-sec">
          <h4>{data.title}</h4>
        </div>
        <div className="row mb-5">
          {photoArray?.length === 0 ? (
            <div className="container">
              <div className="">
                <h4 className="title4">
                  {getText("No photos available", "कोई फ़ोटो उपलब्ध नहीं")}
                </h4>
              </div>
            </div>
          ) : (
            photoArray?.map((item, index) => (
              <div
                key={index}
                className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3"
              >
                {/* <PhotoCard
                  item={item}
                  setVisible={setVisible}
                  setActiveIndex={setActiveIndex}
                  index={index}
                /> */}
                <div className="card-sec">
                  <div
                    className="img-sec photo-gallery-card"
                    onClick={() => {
                      setVisible(true);
                      setActiveIndex(index);
                    }}
                  >
                    <img alt={item.file_path} src={imageUrl + item.file_path} />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <LightBox
        visible={visible}
        setVisible={setVisible}
        photoGallery={photoGallery}
        activeIndex={activeIndex}
      />
    </>
  );
};

export default PhotoGalleryEnv;
